/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Split_Multiview_SuccessInputs */

const en_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Multiview group has been split into ${i?.count} event groups.`)
};

const fr_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le groupe Multiview a été divisé en groupes d'événements ${i?.count}.`)
};

const de_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Die Multiview-Gruppe wurde in ${i?.count}-Ereignisgruppen aufgeteilt.`)
};

const it_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il gruppo Multiview è stato suddiviso in gruppi di eventi ${i?.count}.`)
};

const ru_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Группа Multiview разделена на группы событий ${i?.count}.`)
};

const es_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El grupo Multiview se ha dividido en grupos de eventos ${i?.count}.`)
};

const zh_cn2_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`多视图组已拆分为${i?.count}事件组。`)
};

const ja_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`マルチビューグループは${i?.count}イベントグループに分割されました。`)
};

const hi_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`मल्टीव्यू समूह को ${i?.count} इवेंट समूहों में विभाजित किया गया है।`)
};

const pt_pt2_split_multiview_success = /** @type {(inputs: Split_Multiview_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O grupo Multiview foi dividido em grupos de eventos ${i?.count}.`)
};

/**
* | output |
* | --- |
* | "Multiview group has been split into {count} event groups." |
*
* @param {Split_Multiview_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_success = /** @type {((inputs: Split_Multiview_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_split_multiview_success(inputs)
	if (locale === "de") return de_split_multiview_success(inputs)
	if (locale === "it") return it_split_multiview_success(inputs)
	if (locale === "ru") return ru_split_multiview_success(inputs)
	if (locale === "es") return es_split_multiview_success(inputs)
	if (locale === "zh-CN") return zh_cn2_split_multiview_success(inputs)
	if (locale === "ja") return ja_split_multiview_success(inputs)
	if (locale === "hi") return hi_split_multiview_success(inputs)
	if (locale === "pt-PT") return pt_pt2_split_multiview_success(inputs)
	return en_split_multiview_success(inputs)
});